var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#leaf--KsLuK';
                    var viewUrl = 'sprites.svg#view-leaf--KsLuK';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 14 11',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };